export default function ZinaWrapper(props) {
    return props.children;
}
